import { useCallback, useState } from 'react';

import type { PostView, ReportReason } from '../../api/community.types';
import { AuthorRow } from '../social/AuthorRow';
import { relativeTime } from '../social/format';
import { PostActions, PostAttachmentView, PostBadges, PostOptionsMenu, ReportDialog } from '../social/postParts';
import { useSocial } from '../social/SocialContext';
import { SocialIconButton } from '../social/SocialIcon';

/** Thẻ bài trên bảng tin web: viền + bo 16 (bản mobile là dải tràn ngang). Bấm cả thẻ để mở bài. */
export function PostCard({
  post,
  onOpen,
  onLike,
  onDelete,
  onReport,
}: {
  post: PostView;
  onOpen: () => void;
  onLike: () => void;
  onDelete: () => void;
  onReport: (reason: ReportReason) => void;
}) {
  const { me } = useSocial();
  const [menuOpen, setMenuOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  return (
    <article
      className="sk-card"
      aria-label={`Bài của ${post.author.name}`}
      onClick={onOpen}
      style={{
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-card)',
        padding: '16px 20px 4px',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        cursor: 'pointer',
      }}
    >
      <AuthorRow
        author={post.author}
        time={relativeTime(post.createdAt)}
        right={
          <div style={{ position: 'relative' }}>
            <SocialIconButton name="more" label="Tuỳ chọn" color="var(--text-secondary)" onClick={() => setMenuOpen((v) => !v)} />
            {menuOpen && (
              <PostOptionsMenu
                mine={post.author.id === me?.id}
                onClose={closeMenu}
                onDelete={() => {
                  setMenuOpen(false);
                  onDelete();
                }}
                onReport={() => {
                  setMenuOpen(false);
                  setReportOpen(true);
                }}
              />
            )}
          </div>
        }
      />
      <PostBadges post={post} />
      <div style={{ fontSize: 15, lineHeight: 1.55, color: 'var(--ink)', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{post.body}</div>
      <PostAttachmentView attachment={post.attachment} />
      <PostActions post={post} onLike={onLike} onComment={onOpen} />
      {reportOpen && (
        // Modal render trong cây của thẻ: chặn click nổi lên để không mở bài.
        <div onClick={(e) => e.stopPropagation()} style={{ cursor: 'default' }}>
          <ReportDialog
            onClose={() => setReportOpen(false)}
            onReport={(reason) => {
              setReportOpen(false);
              onReport(reason);
            }}
          />
        </div>
      )}
    </article>
  );
}
